// insurerEndpoints.js
export const insurerEndpoints = (builder) => ({
  getInsurers: builder.query({
    query: (params = {}) => ({
      url: '/common/get-insuranceList',
      method: 'GET',
      params,
    }),
    providesTags: ['Insurance'],
  }),
});
